import React, { useState } from "react";
import Card from "@amzn/meridian/esm/components/card";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";

import ProductFeedback from "./feedback/ProductFeedback";
import { openUrl } from "../utils/zoomSdkUtils";
import { AIMS_PRIVACY_URL, AIMS_WIKI_URL } from "../constants";
import feedbackIcon from "../images/feedback_icon.svg";
import wikiIcon from "../images/wiki_icon.svg";
import privacyIcon from "../images/privacy_icon.svg";

export const INFO_CARD_VARIANT = {
  FEEDBACK: "feedback",
  WIKI: "wiki",
  POLICY: "policy",
};


// Config for each card variant. Feedback opens a modal; wiki/policy open a URL in Zoom.
const CARD_CONFIG = {
  [INFO_CARD_VARIANT.FEEDBACK]: {
    icon: feedbackIcon,
    title: "Feedback",
    description: ["Like what you see?", "Tell us about your experience"],
  },
  [INFO_CARD_VARIANT.WIKI]: {
    icon: wikiIcon,
    title: "Wiki",
    description: "Learn about Amazon Meetings Summary",
    url: AIMS_WIKI_URL,
  },
  [INFO_CARD_VARIANT.POLICY]: {
    icon: privacyIcon,
    title: "Amazon policy",
    description: "Understand Amazon policy on using AI in meetings",
    url: AIMS_PRIVACY_URL,
  },
};

/**
 * InfoCard
 *
 * Shared card used across the inMeeting and inMainClient help/settings surfaces.
 * Renders an icon on the left with a title and one or more description lines on the
 * right. The `variant` selects the icon/text and click behavior:
 * - "feedback": opens the ProductFeedback modal (needs `page`)
 * - "wiki" / "policy": opens the relevant wiki URL in Zoom
 */
const InfoCard = ({ variant, page }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const config = CARD_CONFIG[variant];
  if (!config) return null;

  const { icon, title, description, url } = config;
  const lines = Array.isArray(description) ? description : [description];
  const onClick = variant === INFO_CARD_VARIANT.FEEDBACK ? () => setIsModalOpen(true) : () => openUrl(url);

  return (
    <>
      <Card width="272px" onClick={onClick} spacingInset="none">
        <Row spacing="400" spacingInset="none 400" minHeight={96} alignmentVertical="center" wrap="none">
          <img src={icon} alt=""/>
          <Column spacing="300" alignmentHorizontal="start">
            <Text type="h100" alignment="start">
              {title}
            </Text>
            <Column spacing="none" alignmentHorizontal="start">
              {lines.map((line, index) => (
                <Text key={index} type="b100" color="secondary" alignment="start">
                  {line}
                </Text>
              ))}
            </Column>
          </Column>
        </Row>
      </Card>

      {variant === INFO_CARD_VARIANT.FEEDBACK && (
        <ProductFeedback
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          page={page}
        />
      )}
    </>
  );
};

export default InfoCard;
